import { FormGroup, IconButton, InputAdornment, InputLabel, makeStyles, TextField } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { authContext } from "./FPERouter";
import { useAlert } from "./hooks/useAlert";
import { useTranslation } from "react-i18next";
import LinksTitle, { LinksButton } from "./LinksTitle";
import { useSetRecoilState } from "recoil";
import { audioContextState } from "./store/CopilotDisplaySettingsState";
import { noUseWorkspaceState } from "./store/NoUseWorkspaceState";

const useStyles = makeStyles(theme => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  label: {
    marginTop: 7,
    marginRight: 7,
    width: 85
  },
  formInputArea: {
    marginBottom: "10px"
  },
  margin: {
    marginTop: 10,
  },
  input: {
    width: 270,
    marginTop: 5,
  }
}));

function LoginPage() {

  const auth = useContext(authContext);
  const setNoUseWorkspace = useSetRecoilState(noUseWorkspaceState);
  const {showError} = useAlert();

  const classes = useStyles();
  const [values, setValues] = useState({
    id: '',
    password: '',
    showPassword: false,
  });
  const [buttonDisabled, setButtonDisabled] = useState(false);

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };
  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleKeyDown = async (event) => {
    if(event.keyCode === 13 && values.id !== "" && values.password !== "" && !buttonDisabled) {
      await login(event);
    }
  }

  const history = useHistory();
  const setAudioCtx = useSetRecoilState(audioContextState);

  const {from} = {from: {pathname: '/select'}};
  const login = async (event) => {
    setButtonDisabled(true);
    const ret = await auth.signIn(values);
    if(ret) {
      setAudioCtx(new AudioContext());
      if(event.shiftKey && event.ctrlKey) {
        setNoUseWorkspace(true);
      }
      history.replace(from);
    } else {
      showError('Login failed.', {timeout: 2000, close: false});
      setButtonDisabled(false);
    }
  }

  const {t} = useTranslation();

  return (
    <LinksTitle>
      <div className={classes.paper}>
        <form className={classes.paper}>
          <div className={classes.formInputArea}>
            <FormGroup className={classes.margin}>
              <InputLabel htmlFor="id" className={classes.label}>{t('UserName')}</InputLabel>
              <TextField
                id="id"
                type="text"
                value={values.id}
                onChange={handleChange('id')}
                onKeyDown={handleKeyDown}
                autoFocus={true}
                variant="outlined"
                size="small"
                className={classes.input}
              />
            </FormGroup>
            <FormGroup className={classes.margin}>
              <InputLabel htmlFor="password" className={classes.label}>{t('Password')}</InputLabel>
              <TextField
                id="password"
                type={values.showPassword ? 'text' : 'password'}
                value={values.password}
                onChange={handleChange('password')}
                onKeyDown={handleKeyDown}
                InputProps={{
                  endAdornment:
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {values.showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                }}
                variant="outlined"
                size="small"
                className={classes.input}
              />
            </FormGroup>
          </div>
          <LinksButton
            type="button"
            variant="contained"
            disabled={values.id === "" || values.password === "" || buttonDisabled}
            onClick={login}
            style={{ width: '100%', marginTop: 28 }}
          >
            {t("Login")}
          </LinksButton>
        </form>
      </div>
    </LinksTitle>
  );
}

export default LoginPage;
